// Module
var code = "<div id=\"V-A40827BE-1D94-441D-92B6-4FA53821697E\" data-b-event-mouseover=\"{Binding onover}\" data-b-event-mouseout=\"{Binding onout}\"> <div data-b-component=\"popup\" class=\"v-a40827be-1d94-441d-92b6-4fa53821697e-tooltip-popup tooltip\"> </div> </div> ";
// Exports
export default code;